/**
 * Status pill — Brief 2 §3.
 * Each status has its own colour token. Don't reuse CSS classes across statuses
 * even when they look similar — this keeps the visual workflow obvious.
 */
const STATUS_META = {
  draft: {
    label: "Draft",
    cls: "text-zinc-300 bg-white/[0.04] border-white/[0.10]",
  },
  awaiting_documents: {
    label: "Awaiting documents",
    cls: "text-amber-200 bg-amber-400/[0.08] border-amber-400/30",
  },
  submitted: {
    label: "Submitted",
    cls: "text-blue-200 bg-blue-400/[0.08] border-blue-400/30",
  },
  under_review: {
    label: "Under review",
    cls: "text-purple-200 bg-purple-400/[0.08] border-purple-400/30",
  },
  approved: {
    label: "Approved",
    cls: "text-emerald-200 bg-emerald-400/[0.08] border-emerald-400/30",
  },
  live: {
    label: "Live",
    cls: "text-[#00E5FF] bg-[#00E5FF]/[0.10] border-[#00E5FF]/40 shadow-[0_0_22px_rgba(0,229,255,0.18)]",
  },
  info_requested: {
    label: "Info requested",
    cls: "text-amber-200 bg-amber-400/[0.10] border-amber-400/30",
  },
  declined: {
    label: "Declined",
    cls: "text-rose-200 bg-rose-400/[0.08] border-rose-400/30",
  },
  cancelled: {
    label: "Cancelled",
    cls: "text-zinc-400 bg-zinc-500/[0.08] border-zinc-500/30",
  },
  terminated: {
    label: "Terminated",
    cls: "text-rose-100 bg-rose-400/[0.10] border-rose-400/40",
  },
  suspended: {
    label: "Suspended",
    cls: "text-rose-200 bg-rose-400/[0.08] border-rose-400/30",
  },
};

export default function StatusPill({ status, size = "md" }) {
  const meta = STATUS_META[status] || STATUS_META.draft;
  const sizing =
    size === "sm"
      ? "text-[10px] px-2 py-0.5 tracking-[0.18em]"
      : "text-[10.5px] px-2.5 py-1 tracking-[0.2em]";
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border uppercase font-medium ${sizing} ${meta.cls}`}
    >
      <span
        className={`h-1.5 w-1.5 rounded-full ${
          status === "live" ? "bg-[#00E5FF] animate-pulse" : "bg-current opacity-70"
        }`}
      />
      {meta.label}
    </span>
  );
}

export { STATUS_META };
